import {
  USER_LOGOUT
} from './Login'
import {
  api
} from '../../API/api'
import {
  update_toast,
  print_loading
} from '../../Functions/Toast'
import {
  get_id
} from '../../Functions/Functions'

export const SEND_MAIL_CONTACT = (sujet, texte) => { // envoi du mail de contact
  const toast = get_id(6)
  print_loading(toast)
  return (dispatch) => {
    api('send-mail-contact', {
      sujet: sujet,
      texte: texte
    })
      .then(data => {
        if (data.status === 'OK') {
          update_toast(toast, data.response, 'success')
        } else {
          if (data.data === 'die') {
            dispatch(USER_LOGOUT(false))
          }
          update_toast(toast, data.response, 'error')
        }
      })
      .catch(() => {
        update_toast(toast, undefined, 'error')
      })
  }
}
